
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/long-term-storage-solutions",
      function () {
        return require("private-next-pages/long-term-storage-solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/long-term-storage-solutions"])
      });
    }
  